module.exports = __webpack_public_path__ + "media/icons/cross-3bd841a6.png";